import deep from '@theme-ui/preset-deep';
import { merge } from 'theme-ui';

const theme = merge(deep, {
});

export default theme;
